let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCrSA")).then(() => parcelRequire('crXlB'));